import React from 'react';
import { usePageToolbarContext } from './PageToolbarContext';
import './pageToolbarBar.css';

/**
 * Sticky second strip under the navbar, content-column only (beside sidebar).
 * Hidden when the current page has not registered toolbar actions.
 */
export default function PageToolbarBar() {
  const { toolbarActions } = usePageToolbarContext();

  if (!toolbarActions) return null;

  return (
    <div className="page-toolbar-bar" role="toolbar" aria-label="Page actions">
      <div className="page-toolbar-bar__inner">{toolbarActions}</div>
    </div>
  );
}
